<template>
  <div class="popup_wrap">
    <span @click="openDetailModal">
      <slot />
    </span>
    <!-- 레이어팝업 -->
    <modal @close="closeModal" :open="modal.open" title="체험관 이용 확약서">
      <div>
        <p class="colorbox mb20">한국잡월드 체험관 이용을 온라인으로 예약하고 이용료 사전 결제에 갈음하기 위하여 아래와 같이 확약합니다.</p>
        <ul class="inputBox mb30">
          <li>
            <label for="">단체명</label>
            <span><input type="text" v-model="schulNm" maxlength="50" /></span>
          </li>
          <li>
            <label for="">단체 전화번호</label>
            <span><input type="text" v-model="phoneNum" maxlength="20" /></span>
          </li>
          <li class="wdfull">
            <label for="">단체장</label>
            <span><input type="text" v-model="schulMaster" maxlength="40" /></span>
          </li>
          <li class="wdfull">
            <label for="">단체주소</label>
            <span class="adSchbox">
              <div class="sch mb10">
                <input type="text" v-model="zipcode" placeholder="우편번호" maxlength="7" />
                <a class="btn" @click="postChk">주소검색</a>
              </div>
              <input type="text" class="wdhalf mb10" v-model="genAdd" placeholder="주소" maxlength="300" />
              <input type="text" class="wdhalf" v-model="detAdd" maxlength="128" placeholder="상세주소" />
            </span>
          </li>
          <li>
            <label for="">신청자</label>
            <span><input type="text" v-model="userNm" maxlength="50" /></span>
          </li>
          <li>
            <label for="">신청자 휴대폰</label>
            <span><input type="text" v-model="userMobile" maxlength="20" /></span>
          </li>
        </ul>
        <h5 class="stitle2 mb10">체험예약 내역</h5>
        <p class="colorbox">
          <strong class="tcolor1">체험일</strong>
          &nbsp;
          <span v-if="resultList[0]">{{ resultList[0].expVisitRvdtF }}</span>
        </p>
        <div class="tb_wrap mb10">
          <table class="tb_basic">
            <caption>체험 수료증 리스트</caption>
            <colgroup>
              <col />
              <col />
              <col />
              <col />
              <col />
              <col />
            </colgroup>
            <thead>
              <tr class="tbg">
                <th scope="col">예약번호</th>
                <th scope="col">체험관</th>
                <th scope="col">회차</th>
                <th scope="col">체험인원</th>
                <th scope="col">이용금액(A)</th>
                <th scope="col">할인금액(B)</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(result, i) in resultList" :key="i">
                <td v-if="result.bundleRvNo && i === 0" :rowspan="resultList.length">{{ result.bundleRvNo }}</td>
                <td>
                  {{ result.pdNm }}
                </td>
                <td>
                  {{ result.scheSeqNo }}회차
                  <br />
                  ({{ result.scheTm }})
                </td>
                <td class="tleft">
                  <ul class="tlist1">
                    <li>
                      <strong>체험자</strong>
                      <span>{{ result.experPcnt }}인</span>
                    </li>
                    <li>
                      <strong>보호자</strong>
                      <span>{{ result.leaderPcnt }}인</span>
                    </li>
                  </ul>
                </td>
                <td class="tright">{{ _priceFormat(result.rvAmt + result.dcAmt) }}원</td>
                <td class="tright">{{ _priceFormat(result.dcAmt) }}원</td>
              </tr>
              <tr>
                <td colspan="2">
                  이용금액(A)
                  <br />
                  {{ _priceFormat(totOriginPrice) }}원
                </td>
                <td colspan="2">
                  할인금액(B)
                  <br />
                  {{ _priceFormat(totDcPrice) }}원
                </td>
                <td colspan="2">
                  결제할 금액(A-B)
                  <br />
                  {{ _priceFormat(totSalePrice) }}원
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <p class="mb30">※금액은 당일 이용인원에 따라 달라질 수 있습니다.</p>
        <dl class="linebox mb30">
          <dt class="stitle2 mb10">&lt;유의사항&gt;</dt>
          <dt class="stitle2">[공통]</dt>
          <dd>
            <ul class="tlist">
              <li>30분전에 도착하여 입장료를 결제하고 이용자별로 티켓을 받아 정해진 시간부터 체험할 수 있도록 준비하여 주시기 바랍니다.</li>
              <li>이용인원의 변동이 예상되면 별도로 연락하여 주시기 바랍니다.(전화 1644-1333)</li>
              <li>확약서 팩스 전송처(팩스 031-696-8421)</li>
            </ul>
          </dd>
          <dt class="stitle2">[청소년체험관/숙련기술체험관]</dt>
          <dd>
            <ul class="tlist">
              <li>청소년체험관, 숙련기술체험관은 이용확약서를 제출하면 이용일 15일 전에 예약이 승인되며, 승인 후 체험실을 선착순으로 선택할 수 있습니다.</li>
              <li>체험실을 미리 선택하지 않은 경우, 당일 추천 체험실로 배정됩니다.</li>
              <li>원활한 체험 진행을 위하여 체험 시작 30분 경과 후에는 입장이 불가하며, 최대 20분 경과 후에는 참관으로 진행됨을 알려드립니다.</li>
            </ul>
          </dd>
        </dl>
        <div class="signbox mb50">
          <p class="sign1">{{ d_year }}년 &nbsp;{{ d_month }}월 &nbsp;{{ d_day }}일</p>
          <p class="sign2 mb20">
            <strong>{{ schulMstr }}</strong>
            단체장 (인)
          </p>
          <p class="sign3">한국잡월드 이사장 귀하</p>
        </div>
        <h5 class="stitle2 mb10">이용요금 기준안내</h5>
        <p class="colorbox mb10">
          한국잡월드 어린이·청소년 체험관 이용요금이 아래와 같이 평일·토요일·공휴일 구분 없이 단일 요금으로 조정됩니다.(적용일 2022년 3월 1일(체험일 기준))
        </p>
        <div class="tb_wrap mb10">
          <table class="tb_basic">
            <caption>이용요금 기준안내</caption>
            <colgroup>
              <col width="15%" />
              <col width="15%" />
              <col />
              <col />
            </colgroup>
            <thead>
              <tr class="tbg">
                <th colspan="2" scope="col">대상</th>
                <th scope="col">회차당 이용금액</th>
                <th scope="col">비고</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td colspan="2">청소년체험관/미래직업관</td>
                <td>9,000원</td>
                <td>
                  당일 추가체험 시
                  <br />
                  회차당 6,000원씩 가산
                </td>
              </tr>
              <tr>
                <td rowspan="3">어린이체험관</td>
                <td>체험자</td>
                <td>18,000원</td>
                <td>
                  당일 추가체험 시
                  <br />
                  15,000원 가산
                </td>
              </tr>
              <tr>
                <td>보호자</td>
                <td>9,000원</td>
                <td>
                  당일 추가체험 시
                  <br />
                  5,000원 가산
                </td>
              </tr>
              <tr>
                <td>단체인솔자</td>
                <td>4,000원</td>
                <td>1일 이용요금</td>
              </tr>
              <tr>
                <td colspan="2">진로설계관</td>
                <td>3,000원</td>
                <td>
                  청소년체험관 이용자 무료
                  <br />
                  어린이체험관 이용자 무료
                </td>
              </tr>
              <tr>
                <td colspan="2">숙련기술체험관</td>
                <td>5,000원</td>
                <td></td>
              </tr>
              <tr>
                <td colspan="2">메카이브 K.Ground</td>
                <td>10,000원</td>
                <td></td>
              </tr>
            </tbody>
          </table>
        </div>
        <h5 class="stitle2 mb10">주차요금</h5>
        <div class="tb_wrap mb10">
          <table class="tb_basic">
            <caption>주차요금</caption>
            <colgroup>
              <col width="10%" />
              <col width="28%" />
              <col width="20%" />
              <col />
            </colgroup>
            <tbody>
              <tr>
                <td rowspan="5">일반요금</td>
                <td rowspan="2">
                  기본60분
                  <br />
                  (무료60분 포함 120분에 해당)
                </td>
                <td>소형차</td>
                <td class="price_color">5,000원</td>
              </tr>
              <tr>
                <td>대형차</td>
                <td class="price_color">10,000원</td>
              </tr>
              <tr>
                <td rowspan="2">추가60분당</td>
                <td>소형차</td>
                <td class="price_color">4,000원</td>
              </tr>
              <tr>
                <td>대형차</td>
                <td class="price_color">6,000원</td>
              </tr>
              <tr>
                <td colspan="3">
                  ※ 일 최대요금: 소형차
                  <span class="price_color">20,000원</span>
                  , 대형차
                  <span class="price_color">40,000원</span>
                </td>
              </tr>
              <tr>
                <td colspan="2">체험관 등 이용 고객</td>
                <td colspan="2">
                  소형차
                  <span class="price_color">5,000원</span>
                  / 대형차
                  <span class="price_color">10,000원</span>
                  <br />
                  1시간 무료, 1일 정액권( 소형차
                  <span class="price_color">5,000원</span>
                  / 대형차
                  <span class="price_color">10,000원</span>
                  )
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <template slot="footer">
        <div class="btn_area btn_wrap">
          <a class="btn btn_bg color btn_popup left" @click="savePledge">저장</a>
          <a class="btn btn_bg gray right" @click="closeModal">닫기</a>
        </div>
      </template>
      <!-- /footer -->
    </modal>
  </div>
</template>

<script>
import api from '@/api/api_config';
import { mapActions } from 'vuex';
import { isLoggedIn, gfn_popup } from '@/utils/reserve';
import Modal from '@/components/common/Modal.vue';
import TabItem from '@/components/common/TabItem.vue';

export default {
  components: { Modal, TabItem },
  props: {
    bundleRvNo: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      modal: {
        open: false,
      },
      type: 'W',
      resultList: [],
      schulNm: '',
      phoneNum: '',
      schulMaster: '',
      detAdd: '',
      genAdd: '',
      zipcode: '',
      userNm: '',
      userMobile: '',
      schulMstr: '',
      d_year: '',
      d_month: '',
      d_day: '',
    };
  },
  computed: {
    totOriginPrice() {
      return this.resultList.reduce((a, e) => a + e.rvAmt + e.dcAmt, 0);
    },
    totDcPrice() {
      return this.resultList.reduce((a, e) => a + e.dcAmt, 0);
    },
    totSalePrice() {
      return this.resultList.reduce((a, e) => a + e.rvAmt, 0);
    },
  },
  watch: {
    'modal.open': function (to) {
      if (to) {
        this.loadGrpDcdfpr();
      }
    },
    schulNm(to) {
      this.schulMstr = to;
    },
  },
  methods: {
    ...mapActions('reserve', ['editReserveInfo']),
    openModal() {
      this.modal.open = true;
    },
    closeModal() {
      this.modal.open = false;
    },
    openEdit() {
      this.type = 'P';
      this.modal.open = true;
    },
    openDetailModal() {
      if (isLoggedIn()) {
        this.openModal();
      }
    },
    jusoCallBack(roadFullAddr, roadAddrPart1, addrDetail, roadAddrPart2, engAddr, jibunAddr, zipNo, admCd, rnMgtSn, bdMgtSn) {
      this.detAdd = addrDetail;
      this.genAdd = roadAddrPart1 + roadAddrPart2;
      this.zipcode = zipNo;
    },
    postChk() {
      if (!window.jusoCallBack) {
        window.jusoCallBack = this.jusoCallBack;
      }
      gfn_popup('/registerJusoPopup.do', '570', '420', '우편번호검색');
    },
    async loadGrpDcdfpr() {
      const param = {
        bundleRvNo: this.bundleRvNo,
        type: this.type,
      };
      let form = new FormData();
      for (let key in param) {
        form.append(key, param[key]);
      }
      try {
        const result = await api.post('/api/reservation/' + this.bundleRvNo + '/grpDcdfpr', form);
        if (result.data.success) {
          const response = result.data.response;
          this.resultList = response.resultList;
          // 기존자료 입력
          if (response.appointList) {
            const appointList = response.appointList;

            this.schulNm = appointList[0].schoolNm;
            this.phoneNum = appointList[0].userPhoneNum;
            this.schulMaster = appointList[0].principalNm;
            this.detAdd = appointList[0].etcAddress;
            this.genAdd = appointList[0].basicAddress;
            this.zipcode = appointList[0].postCd;
            this.userNm = appointList[0].writerNm;
            this.userMobile = appointList[0].userMobileNum;
            this.schulMstr = appointList[0].schoolNm;

            const modDt = appointList[0].modDt;
            this.d_year = modDt.substr(0, 4);
            this.d_month = modDt.substr(4, 2);
            this.d_day = modDt.substr(6, 2);
          } else if (response.userInfo?.[0]) {
            const userInfo = response.userInfo[0];
            this.schulNm = userInfo.orgName || '';
            this.phoneNum = userInfo.phoneNumber || '';
            this.detAdd = userInfo.etcAddress || userInfo.orgName || '';
            this.genAdd = userInfo.basicAddress || '';
            this.zipcode = userInfo.postCode || '';
            this.userNm = userInfo.userName || '';
            this.userMobile = userInfo.userMobileNum || '';
            this.schulMstr = userInfo.orgName || '';

            const aa = new Date();
            this.d_year = aa.getFullYear();
            this.d_month = aa.getMonth() + 1;
            this.d_day = aa.getDate();
          }
        }
      } catch (e) {
        console.log(e);
      }
    },
    async savePledge() {
      if (!this.schulNm) {
        alert('단체명을 입력하여 주십시오.');
        return false;
      }
      if (!this.phoneNum) {
        alert('전화번호를 입력하여 주십시오.');
        return false;
      }
      if (!this.schulMaster) {
        alert('단체장 이름을 입력하여 주십시오.');
        return false;
      }

      if (!this.detAdd || !this.genAdd || !this.zipcode) {
        alert('주소를 정확히 입력하여 주십시오.');
        return false;
      }
      if (!this.userNm) {
        alert('신청자 이름을 입력하여 주십시오.');
        return false;
      }
      if (!this.userMobile) {
        alert('신청자 핸드폰을 입력하여 주십시오.');
        return false;
      }

      const param = {
        bundleRvNo: this.bundleRvNo,
        schulNm: this.schulNm,
        phoneNum: this.phoneNum,
        schulMaster: this.schulMaster,
        detAdd: this.detAdd,
        genAdd: this.genAdd,
        zipcode: this.zipcode,
        userNm: this.userNm,
        userMobile: this.userMobile,
        schulMstr: this.schulMstr,
      };
      let form = new FormData();
      for (let key in param) {
        form.append(key, param[key]);
      }
      customConfirm('저장 하시겠습니까?', async (confirm) => {
        if (confirm) {
          const result = await api.post('/resvr/insertGrpDcdfpr.do', form);
          alert(result.data.resulMsg);
          location.reload();
        }
      });
    },
  },
  created() {},
  destroyed() {
    if (window.jusoCallBack) {
      window.jusoCallBack = undefined;
    }
  },
};
</script>

<style lang="scss" scoped>
::v-deep .pop_layer {
  min-width: 1024px;
  left: calc(50% - 500px);
  margin-left: 0;
}
::v-deep .pop_layer .price_color {
  color: #0177c0;
}
@media all and (max-width: 1024px) {
  ::v-deep .pop_layer {
    min-width: 100%;
    left: 0;
  }
}
.popup_wrap {
  display: inline-block;
  & a {
    cursor: pointer;
  }
}
</style>
